/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



/**
 * API endpoint URL constants for core backend services.
 * Defines all REST API paths for medical system operations including appointments,
 * patients, billing, prescriptions, and telemedicine features.
 */
export enum CoreAPI_URLs {
  ACCOUNTING_MOVEMENT_GENERAL_OPERATIONS = "/accounting-movement",
  ACCOUNTING_MOVEMENT_GET_ALL = "/accounting-movement/all",
  PAYMENT_GENERAL_OPERATIONS = "/payment",
  PAYMENT_GET_ALL = "/payment/all",
  PAYMENT_GET_BY_ACCOUNTING_MOVEMENTS = "/payment/get-by-accounting-movements",
  PAYMENT_ASSET_RELATION = "/payment-asset/relation",
  PROVIDER_ASSET_RELATION = "/provider-asset/relation",
  EXCHANGE_RATE_GENERAL_OPERATIONS = "/exchange-rate",
  BILLING_ENCOUNTER_GENERAL_OPERATIONS = "/billing-encounter",
  BILLING_ENCOUNTER_GET_ALL = "/billing-encounter/all",
  BILLING_ENCOUNTER_GET_ALL_BY_MOVEMENT = "/billing-encounter/all/by-accounting-movements",
  BILLING_ENCOUNTER_UPDATE_BATCH = "/billing-encounter/batch",
  BILLING_ENCOUNTER_BY_PAYMENT_IDS = "/billing-encounter/by-payment-ids",
  PROXY_BASE_PATH = "/asset/blob-proxy",
  APPOINTMENTS_GENERAL_OPERATIONS = "/appointments",
  APPOINTMENTS_GET_ALL = "/appointments/all",
  ASSET_PATIENT_RELATION = "/asset/relation",
  ASSETS = "/asset",
  ASSETS_UPLOAD = "/asset/upload",
  CASE_APPOINTMENT_GENERAL_OPERATIONS = "/medicalCase/appointment",
  CASE_APPOINTMENT_GET_ALL = "/medicalCase/appointment/all",
  PROVIDER_CREATE_ALL_MODEL = "/provider/create-all-model",
  PROVIDER_GENERAL_OPERATIONS = "/provider",
  PROVIDER_GET_BY_USER = "/provider/by-user",
  PROVIDER_GET_DOCTOR = "/provider/doctor",
  PROVIDER_GET_NURSE = "/provider/nurse",
  PROVIDER_GET_ALL = "/provider/all",
  DOCTOR_GET_ALL = "/provider/doctor/all",
  NURSE_GET_ALL = "/provider/nurse/all",
  FACILITY_GENERAL_OPERATIONS = "/facility",
  FACILITY_GET_ALL = "/facility/all",
  GENERAL_SETTINGS = "/general-settings",
  HPI_TEMPLATE_GENERAL_OPERATIONS = "/templates",
  HPI_TEMPLATE_GET_ALL = "/templates/all",
  HPI_TEMPLATE_RESTORE = "/templates/restore",
  HPI_TEMPLATE_DELETE_PERMANENTLY = "/templates/delete-permanently",
  INSURANCE_GENERAL_OPERATION = "/insurance",
  INSURANCE_GET_ALL = "/insurance/all",
  MEDICAL_CASE_GENERAL_OPERATIONS = "/medicalCase",
  MEDICAL_CASE_GET_ALL = "/medicalCase/all",
  NOTIFICATIONS_GENERAL_OPERATIONS = "/notifications",
  NOTIFICATIONS_GET_ALL = "/notifications/all",
  NOTIFICATIONS_MARK_AS_READ = "/notifications/mark-as-read",
  NOTIFICATIONS_SEND_FEEDBACK_EMAIL = "/notifications/mail-feedback",
  NOTIFICATIONS_MARK_ALL_AS_READ = "/notifications/mark-all-as-read",
  PATIENT_INSURANCE_GENERAL_OPERATION = "patient/insurance",
  PATIENT_INSURANCE_GET_ALL = "patient/insurance/all",
  PATIENT_PHARMACY_RELATION_GENERAL_OPERATION = "patient/pharmacy",
  PATIENTS_CREATE_ALL_MODEL = "/patients/create-all-model",
  PATIENTS_GENERAL_OPERATIONS = "/patients",
  PATIENTS_GET_ALL = "/patients/all",
  PAYER_GENERAL_OPERATIONS = "/payer",
  PAYER_GET_ALL = "/payer/all",
  PERSONS_GENERAL_OPERATIONS = "/person",
  PERSONS_GET_BY_USER_ID = "/person/by-user/id",
  PERSONS_GET_ALL = "/person/all",
  PERSONS_RELATION_GENERAL_OPERATIONS = "/person/relation",
  PERSONS_RELATION_GET_ALL = "/person/relation/all",
  PHARMACIES = "/pharmacy/all",
  PHARMACIES_GENERAL_OPERATION = "/pharmacy",
  PRICING_GENERAL_OPERATIONS = "/pricing",
  PRICING_GET_ALL = "/pricing/all",
  PROGRESS_NOTE_GENERAL_OPERATION = "/progress-note",
  PROGRESS_NOTE_GET_ALL = "/progress-note/all",
  RESOURCE_GENERAL_OPERATIONS = "/resource",
  RESOURCE_GET_ALL = "/resource/all",
  RESOURCES_GET_ALL = "resource/all",
  RESOURCES_GET_ALL_BY_FACILITY = "resource/all-by-facility",
  USERS_AUTH_LOGIN = "/user/auth/login",
  USERS_GENERAL_OPERATIONS = "/user",
  USERS_RETRIEVE_DELETE = "/user/id",
  VITALS_GENERAL_OPERATION = "/vitals",
  VITALS_GET = "/vitals/all",
  VITALS_UPLOAD_PDF = "/vitals/upload-pdf",
  ACCOUNTING_GENERAL_OPERATIONS = "/accounting",
  ACCOUNTING_BY_PATIENT_ID = "/accounting/by-patient",
  ACCOUNTING_GET_ALL = "/accounting/all",
  ACCOUNTING_BY_PAYER = "/accounting/by-payer",
  PRESCRIPTION_TEMPLATE_GENERAL_OPERATIONS = "/templates",
  PRESCRIPTION_TEMPLATE_GET_ALL = "/templates/all",
  PRESCRIPTION_GENERAL_OPERATION = "/prescriptions",
  PRESCRIPTION_NEW_VERSION = "/prescriptions/new-version",
  PRESCRIPTION_GET_VERSIONS = "/prescriptions/versions",
  RESOURCE_BATCH_CREATE = "/resource/batch",
  PASSWORD_RECOVERY_SEARCH = "/user/recover-password/recover",
  PASSWORD_RECOVERY_SECURITY_CODE = "/user/recover-password/verify",
  PASSWORD_RECOVERY_NEW_PASSWORD = "/user/recover-password/newPass",
  USERS_GET_ALL = "/user",
  USERS_GET_ALL_PERSONS = "/user/allUsersPersons",
  USERS_CREATE_ALL_MODEL = "/user/create-all-model",
  VITALS_ASSET_RELATION = "/vitals-asset/relation",
  VIDEOCHAT_JOIN = "/videochat/join",
  VIDEOCHAT_GUEST_JOIN_BY_CODE = "/videochat/guest/join-by-code",
  VIDEOCHAT_GUEST_LEAVE = "/videochat/guest/leave",
  VIDEOCHAT_GUEST_UNLOAD = "/videochat/guest/unload",
  VIDEOCHAT_SEND_MESSAGE = "/videochat/send-message",
  VIDEOCHAT_SEND_MESSAGE_GUEST = "/videochat/send-message-guest",
  VIDEOCHAT_GET_MESSAGES = "/videochat/get-messages",
  VIDEOCHAT_GET_MESSAGES_GUEST = "/videochat/get-messages-guest",
  VIDEOCHAT_GENERATE_ACCESS_CODE = "/videochat/generate-access-code",
  VIDEOCHAT_LEAVE = "/videochat/leave",
  VIDEOCHAT_UNLOAD = "/videochat/unload",
  VIDEOCHAT_END = "/videochat/end",
  VIDEOCHAT_PARTICIPANT_NAMES = "/videochat/participant-names",
  VIDEOCHAT_GUEST_VALIDATE = "/videochat/guest/validate",
  VIDEOCHAT_GUEST = "/videochat/guest/",
  INSURANCE_TRANSACTION_GENERAL_OPERATION = "insurance-transaction",
  INSURANCE_TRANSACTION_GET_ALL = "insurance-transaction/all",
  ACTIVITY_LOGS_GET_ALL = "/activity-logs/all",
  ACTIVITY_LOGS_RECENT = "/activity-logs/recent",
  ACTIVITY_LOGS_BY_USER = "/activity-logs/by-user",
  ASSET_VIEWER = "/asset-viewer",
}
